import { IContactSubmission } from '../models/contact-submission';
import { ETrackType } from '../models/faq.model';
import { IPaginationData, IPaginationQuery, request } from './base';

export enum ESubmissionStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}

interface IContactSubmissionListQuery extends IPaginationQuery {
  track?: ETrackType;
  status?: ESubmissionStatus;
  order?: 'ASC' | 'DESC';
  sort_by?: string;
  keyword?: string;
  email?: string;
}

interface IApprovalRequest {
  status: string;
  review_notes?: string;
}

interface IRejectionRequest {
  status: string;
  review_notes: string;
}

function getList(query: IContactSubmissionListQuery) {
  return request<IPaginationData<IContactSubmission>>({
    url: '/contact-submission',
    method: 'GET',
    params: query,
  });
}

function getDetail(id: string) {
  return request<IContactSubmission>({
    url: `/contact-submission/${id}`,
    method: 'GET',
  });
}

function approve(id: string, data: IApprovalRequest) {
  return request<IContactSubmission>({
    url: `/contact-submission/${id}/approve`,
    method: 'PATCH',
    data,
  });
}

function reject(id: string, data: IRejectionRequest) {
  return request<IContactSubmission>({
    url: `/contact-submission/${id}/reject`, 
    method: 'PATCH',
    data,
  });
}

function getStatistics() {
  return request<{
    total: number;
    pending: number;
    approved: number;
    rejected: number;
    by_track: Record<ETrackType, number>;
  }>({
    url: '/contact-submission/statistics',
    method: 'GET',
  });
}

function remove(id: string) {
  return request<IContactSubmission>({
    url: `/contact-submission/${id}`,
    method: 'DELETE',
  });
}

const contactSubmissionApi = Object.freeze({
  getList,
  getDetail,
  approve,
  reject,
  getStatistics,
  remove,
});

export default contactSubmissionApi;
